"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
var _Modal = _interopRequireDefault(require("../../../../common/Modal/Modal"));
var _APCheckbox = _interopRequireDefault(require("../../../../common/APCheckbox/APCheckbox"));
var _APButton = _interopRequireDefault(require("../../../../common/APButton"));
var _config = _interopRequireDefault(require("../../../../../config"));
require("./EnableMarginConfirmationModal.css");
var _commonComponent = require("../../../../../propTypes/commonComponent");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('enable-margin-confirmation');
var EnableMarginConfirmationModal = function EnableMarginConfirmationModal(_ref) {
  var isOpen = _ref.isOpen,
    close = _ref.close,
    buttonIsDisabled = _ref.buttonIsDisabled,
    submitting = _ref.submitting,
    submitForm = _ref.submitForm,
    decline = _ref.decline,
    isReadOnly = _ref.isReadOnly;
  var _useTranslation = (0, _reactI18next.useTranslation)('margin'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    title: t('Margin Trading'),
    close: close,
    customClass: bemClasses('modal')
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: bemClasses('header')
  }, t('Margin Terms & Conditions')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('modal-body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(bemClasses('scrollable'), " ").concat(isReadOnly ? 'read-only' : ''),
    dangerouslySetInnerHTML: {
      __html: t(_config["default"].MarginTrading.terms)
    }
  }), !isReadOnly && /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('checkboxes')
  }, /*#__PURE__*/_react["default"].createElement(_APCheckbox["default"], {
    name: "terms",
    id: "agree",
    label: t("I've read all Terms & Conditions")
  }))), !isReadOnly && /*#__PURE__*/_react["default"].createElement("div", {
    className: "ap-modal__footer ".concat(bemClasses('modal-footer'))
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    disabled: buttonIsDisabled,
    onClick: submitForm,
    styleName: _commonComponent.styleNames.additive
  }, submitting ? t('Pending') : t('ACCEPT TERMS')), /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    type: "button",
    onClick: decline
  }, t('DECLINE'))));
};
var _default = exports["default"] = EnableMarginConfirmationModal;